// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "jobs";

export const jobKeys = {
  // Base keys
  all: [collection],
  meta: (id) => [collection, "meta", id],
  config: (id) => [collection, "config-check", id],
  count: (id) => [...jobKeys.all, "count", id],
  details: () => [collection, "detail"],
  coordinators: (id) => [collection, "coordinators", id],
  detail: (id) => [...jobKeys.details(), id],
  allocatedSum: (id) => [collection, "allocated", id],
  bucketedSum: (id) => [collection, "bucketed", id],
  allApprovedHours: (id, dateRange) => [collection, "approved", id, dateRange],
  allLoggedHours: (id, dateRange) => [collection, "logged", id, dateRange],
  milestones: (jobId) => [...jobKeys.detail(jobId), "milestones"],
  configAmount: (id) => [collection, "config", id],
  collectedBillables: (id) => [collection, "billables", "collected", id],
  dates: (id) => [collection, "dates", id],
  uncollectedBillables: (id) => [collection, "billables", "uncollected", id],
  inProgressCount: () => [collection, "in-progress"],
  inReviewCount: () => [collection, "in-review"],
};

export function invalidateJobQueries() {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection,
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

// Additional helper for invalidating all job queries
export function invalidateAllJobQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
